export default __webpack_public_path__ + "static/media/IFW_SoftwareCHARTS-06.3fb80f95.png";